<template>
  <div class="appointment-analysis">
    <div class="grid">
      <div id="chart1" ref="chart1" class="chart"/>
      <div id="chart2" ref="chart2" class="chart"/>
      <div id="chart3" ref="chart3" class="chart"/>
    </div>
  </div>
</template>

<script>
  import echarts from "echarts";
  export default {
    name: "AppointmentOrderAnalysis",
    data() {
      return {
        chart1: null,
        chart2: null,
        chart3: null,
        resizeTimer: null,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.initCharts();
        window.addEventListener("resize", this.handleResize);
      });
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.handleResize);
      if (this.chart1) { this.chart1.dispose(); this.chart1 = null; }
      if (this.chart2) { this.chart2.dispose(); this.chart2 = null; }
      if (this.chart3) { this.chart3.dispose(); this.chart3 = null; }
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
    },
    methods: {
      initCharts() {
        // 初始化实例
        this.chart1 = echarts.init(this.$refs.chart1);
        this.chart2 = echarts.init(this.$refs.chart2);
        this.chart3 = echarts.init(this.$refs.chart3);

        // 测试数据
        const submitData = [
          { name: "Alice", value: 24 },
          { name: "Bob", value: 18 },
          { name: "Charlie", value: 8 },
          { name: "Dave", value: 12 },
        ];

        const manHourCategories = submitData.map((d) => d.name);
        const manHourValues = [120, 95, 60, 40];

        const companyData = [
          { name: "Company A", value: 35 },
          { name: "Company B", value: 22 },
          { name: "Company C", value: 14 },
        ];

        // 图表1：提交数量环形图
        const option1 = {
          title: { text: "提交数量", left: "center", top: 8, textStyle: { fontSize: 14 } },
          tooltip: { trigger: "item" },
          legend: { orient: "vertical", left: "left" },
          series: [
            {
              name: "提交数",
              type: "pie",
              radius: ["45%", "70%"],
              avoidLabelOverlap: false,
              label: { show: true, position: "inside", formatter: "{b}: {c}" },
              emphasis: { label: { show: true, fontSize: "16", fontWeight: "bold" } },
              data: submitData,
            },
          ],
        };

        // 图表2：不同人工时柱状图
        const option2 = {
          title: { text: "工时", left: "center", top: 8, textStyle: { fontSize: 14 } },
          tooltip: { trigger: "axis" },
          xAxis: { type: "category", data: manHourCategories, axisTick: { alignWithLabel: true } },
          yAxis: { type: "value" },
          series: [
            {
              name: "工时 (h)",
              type: "bar",
              barWidth: "40%",
              data: manHourValues,
              itemStyle: { color: "#2d8cf0" },
            },
          ],
        };

        // 图表3：不同公司客服数量环形图
        const option3 = {
          title: { text: "客服数量", left: "center", top: 8, textStyle: { fontSize: 14 } },
          tooltip: { trigger: "item" },
          legend: { orient: "vertical", left: "left" },
          series: [
            {
              name: "客服数",
              type: "pie",
              radius: ["45%", "70%"],
              avoidLabelOverlap: false,
              label: { show: true, position: "inside", formatter: "{b}: {c}" },
              emphasis: { label: { show: true, fontSize: "16", fontWeight: "bold" } },
              data: companyData,
            },
          ],
        };

        this.chart1.setOption(option1);
        this.chart2.setOption(option2);
        this.chart3.setOption(option3);
      },
      // 防抖处理窗口大小改变事件
      handleResize() {
        if (this.resizeTimer) clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.resizeCharts();
        }, 100);
      },
      resizeCharts() {
        // 更强制的重排方法，确保容器尺寸正确计算
        const forceRepaint = () => {
          // 保存当前显示方式
          const chartDivs = [
            document.getElementById("chart1"),
            document.getElementById("chart2"),
            document.getElementById("chart3"),
          ];
          
          // 强制重排
          chartDivs.forEach(div => {
            if (div) {
              div.style.display = "none";
              div.offsetWidth; // 触发重排
              div.offsetHeight; // 触发重排
              div.style.display = "";
            }
          });
          
          // 重绘图表
          setTimeout(() => {
            if (this.chart1) this.chart1.resize();
            if (this.chart2) this.chart2.resize();
            if (this.chart3) this.chart3.resize();
          }, 0);
        };
        
        // 先等待DOM更新，再执行强制重排
        this.$nextTick(forceRepaint);
      },
    },
  };
</script>

<style scoped>
.appointment-analysis {
  padding: 12px;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 360px 360px;
  grid-gap: 12px;
}
.chart {
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 8px;
  box-sizing: border-box;
}
/* 将第三个图放到第二行左侧 */
#chart3 {
  grid-column: 1 / 2;
  grid-row: 2 / 3;
}
/* 默认第一个在 (1,1)，第二个在 (1,2)，第三个在 (2,1) */
</style>
